enum PanelUploadFilesActionType {
    PANEL_UPLOAD_FILES_REQUEST_DATA = "PANEL_UPLOAD_FILES_REQUEST_DATA",
    PANEL_UPLOAD_FILES_LOAD_DATA = "PANEL_UPLOAD_FILES_LOAD_DATA",
    PANEL_UPLOAD_FILES_HIDE_SPINNER = "PANEL_UPLOAD_FILES_HIDE_SPINNER",
}

export default PanelUploadFilesActionType;